
export default function AuthenticationTitleText() {
    // Used in AuthenticationScreen to display login
    // title text

    // BUILD
    return (
        <h1 className={"text-neoTextColor font-medium text-[20px]"}>
            {"Connexion"}
        </h1>
    );
}